import type { Project } from "@brickme/project-core/src/model/project.ts";
import type { Palette } from "@brickme/project-core/src/model/picture.ts";
import type { TransportParseResult } from "@brickme/project-core/src/model/transport.ts";
import {
	corePictureToTransportPicture,
	isoDateTimeString,
	isoStringToDate,
	transportPictureConfigurationToCore,
} from "@brickme/project-core/src/model/transport.ts";
import { isEqual, uniqWith } from "lodash-es";
import type { CreateProjectInput } from "~/api/types.generated.ts";
import type { SavedDesignProjectFragment } from "~/api/saved-design-project-fragment.generated.ts";

function apiProjectToCore(
	project: SavedDesignProjectFragment,
	currentPalette: Palette,
): TransportParseResult<Project> {
	const currentPictureResult = transportPictureConfigurationToCore(
		// TODO: Work towards better transport transform functions with api schemas
		project.currentPicture as any,
		currentPalette,
	);
	const otherVersionResults = project.otherVersions.map((o) =>
		// TODO: Work towards better transport transform functions with api schemas
		transportPictureConfigurationToCore(o as any, currentPalette),
	);
	const warnings = uniqWith(
		[
			...Array.from(currentPictureResult.warnings),
			...otherVersionResults.flatMap((o) => Array.from(o.warnings)),
		],
		isEqual,
	);
	return {
		warnings: new Set(warnings),
		result: {
			currentPicture: currentPictureResult.result,
			otherVersions: otherVersionResults.map((o) => o.result),
			updatedAt: isoStringToDate(project.updatedAt.toString()).getTime(),
		},
	};
}

function coreProjectToTransportProject(
	project: Project,
	currentPictureBuildNumberOfColours: number,
): Omit<CreateProjectInput, "tempSourceImageKey"> {
	return {
		currentPicture: corePictureToTransportPicture(
			project.currentPicture,
			currentPictureBuildNumberOfColours,
		),
		// Not used anywhere and won't have build, so pass 0
		otherVersions: project.otherVersions.map((p) =>
			corePictureToTransportPicture(p, 0),
		),
		updatedAt: isoDateTimeString(project.updatedAt),
	};
}

export { apiProjectToCore, coreProjectToTransportProject };
